/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {DeleteMemoriesAppRequest} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'
import {DeleteMemoriesAppResponse} from '@cash-web/protos/squareup/cash/kgoosememorystore/api/v1beta1/app_service.pb'


export const deleteMemoriesApp = (request: DeleteMemoriesAppRequest, options?: CashRequestOptions) => post<DeleteMemoriesAppRequest, DeleteMemoriesAppResponse>("/2.0/cash/delete-memories-app", request, {...options, rejectOnError: true })